import { RepositoryFactory } from '../repositories/PassageApi/RepositoryFactory.js'
import CredentialsService from '../services/CredentialsService.js'

const SecretaryRepository = RepositoryFactory.get('secretary')

class SecretaryService {
  static async getSecretaries (params) {
    try {
      return await SecretaryRepository.getSecretaries(CredentialsService.getCurrentTenantId(), params)
    } catch (error) {
      console.log(error)
    }
  }
}

export default SecretaryService
